import loadable from "@loadable/component";

export const Map = loadable(
  () => import(/* webpackChunkName: "mapbox-map" */ "./main"),
  {
    resolveComponent: (c) => c.Map,
    ssr: false,
  }
);
export const Layer = loadable(
  () => import(/* webpackChunkName: "mapbox-map" */ "./main"),
  {
    resolveComponent: (c) => c.Layer,
    ssr: false,
  }
);
export const Feature = loadable(
  () => import(/* webpackChunkName: "mapbox-map" */ "./main"),
  {
    resolveComponent: (c) => c.Feature,
    ssr: false,
  }
);
export const Marker = loadable(
  () => import(/* webpackChunkName: "mapbox-map" */ "./main"),
  {
    resolveComponent: (c) => c.Marker,
    ssr: false,
  }
);
export const Popup = loadable(
  () => import(/* webpackChunkName: "mapbox-map" */ "./main"),
  {
    resolveComponent: (c) => c.Popup,
    ssr: false,
  }
);
export const Context = loadable(
  () => import(/* webpackChunkName: "mapbox-map" */ "./main"),
  {
    resolveComponent: (c) => c.Context,
    ssr: false,
  }
);
export const DraggableMarker = loadable(
  () => import(/* webpackChunkName: "mapbox-map" */ "./main"),
  {
    resolveComponent: (c) => c.DraggableMarker,
    ssr: false,
  }
);
